.ux-tab-button {
  cursor: pointer;
  display: block;
  height: 36px;

  +.ux-tab-button {
    margin-left: $tab-margin-horizontal;
  }

  &__label {
    @include font(bold);
    align-items: center;
    color: $color-black;
    cursor: pointer;
    display: inline-flex;
    flex-flow: row nowrap;
    font-size: $size-text-small;
    height: 100%;
    justify-content: center;
    line-height: 1;
    margin-left: 15px;
    margin-right: 15px;
    padding: 0;
    position: relative;
    text-rendering: optimizelegibility;
    text-transform: uppercase;
    transition: color $animationSpeed-fast $animationEasing-easeInOut;

    @container style(--trumpf-ux-animations: disabled) {
      transition: none !important;
    }


    @media screen and (width >=769px) {
      margin-left: 20px;
      margin-right: 20px;
    }

    &:hover {
      color: $color-gray-70;
    }
  }

  &.is-active {
    background-color: $color-blue-1;
  }

  &.is-active .ux-tab-button__label {
    color: $color-white;
  }

  &--folder {
    background: $color-blue-5;
    height: auto;
    padding: 10px 30px;

    @media only screen and (min-width: $bp-xxl) {
      padding: 15px 30px;
    }

    +.ux-tab-button--folder {
      margin-left: 10px;
    }

    .ux-tab-button__label {
      @include font(light);
      color: $color-black;
      text-transform: none;
      font-size: $size-text-medium-plus;
      margin: 0;

      @media only screen and (min-width: $bp-xxl) {
        font-size: $size-text-normal;
      }

      &:hover {
        color: $color-black;
      }
    }

    &:hover {
      background-color: $color-blue-80;
    }

    &.is-active {
      background: $color-white;

      .ux-tab-button__label {
        color: $color-black;
      }
    }
  }
}